export default __webpack_public_path__ + "static/showcase-brand-identity-design-work@2x-7357c15123cbee1a2e05d0745746f457.png";